module.exports = __webpack_public_path__ + "static/media/privacy-hexagon.6416a88c.svg";